/* Brilliant Dog Co. — small progressive enhancements. Everything works without this file. */
(function () {
  function initSticky() {
    document.querySelectorAll('[data-bdc-sticky]').forEach(function (bar) {
      var target = document.getElementById(bar.getAttribute('data-bdc-sticky'));
      if (!target || !('IntersectionObserver' in window)) return;
      var btn = bar.querySelector('button, a');
      document.body.classList.add('bdc-has-sticky');
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-shown', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (btn) btn.tabIndex = show ? 0 : -1;
        });
      }).observe(target);
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-bdc-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bdcReady) return;
      gallery.dataset.bdcReady = '1';
      var stage = gallery.querySelector('[data-bdc-stage]');
      var mockup = gallery.querySelector('[data-bdc-mockup]');
      gallery.querySelectorAll('[data-bdc-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gallery.querySelectorAll('[data-bdc-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          var existing = stage.querySelector('.bdc-pdp__photo');
          if (existing) existing.remove();
          var src = btn.getAttribute('data-src');
          if (!src) { if (mockup) mockup.hidden = false; return; }
          if (mockup) mockup.hidden = true;
          var img = document.createElement('img');
          img.className = 'bdc-pdp__photo';
          img.src = src;
          img.alt = btn.getAttribute('data-alt') || '';
          stage.appendChild(img);
        });
      });
    });
  }

  function init() { initSticky(); initGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); });
})();
